export * from './baDynamicModulesMenu.component';
